import RestService from '@onpace/api_service/rest_service'

////////// Configuration

let clientConfiguration = null
const configurableClients = []

/// Configures the client with the given attributes.
///
/// This configuration will be applied to all clients which have been registered using +registerConfigurableClient+.
///
/// The following options are accepted:
/// [baseUrl]
///   The base URL which hosts Onspace. This should correspond to the Rails application's root URL, with the full domain
///   name if required.
/// [defaultParams]
///   An object of additional parameters to include on every request. If a parameter exists in both the default and
///   request's parameter list, the request will take precedence.
/// [defaultHeaders]
///   An object of additional headers to include on every request. If a header exists in both the default and request's
///   header list, the request will take precedence.
export function configureClient(options = {}) {
  clientConfiguration = options
  configurableClients.forEach((client) => applyClientConfiguration(client, clientConfiguration))
}

/// Registers the given client for the global configuration.
///
/// If a configuration has already been set, it will be applied immediately. The client should be a RestService, which
/// will have it's configuration applied automatically. Alternatively, if the client has a +applyConfiguration+
/// function, it will instead be called with the configuration object as the only argument.
export function registerConfigurableClient(client) {
  if (clientConfiguration !== null) {
    applyClientConfiguration(client, clientConfiguration)
  }

  configurableClients.push(client)
}

function applyClientConfiguration(client, configuration) {
  if (typeof client.applyConfiguration === 'function') {
    client.applyConfiguration(configuration)
  } else {
    client.baseUrl = configuration.baseUrl || null
    client.defaultParams = configuration.defaultParams || null
    client.defaultHeaders = configuration.defaultHeaders || null
  }
}

////////// Service

class OnspaceRestService extends RestService {
  /// Performs a request.
  ///
  /// This overrides RestService.request to automatically inject a CSRF token as required for non-GET requests.
  async request(method, path, options = {}) {
    if (method !== 'GET') {
      const csrfElement = document.querySelector('meta[name="csrf-token"]')
      if (csrfElement) {
        if (typeof options.headers !== 'object') { options.headers = {} }

        options.headers['X-CSRF-Token'] = csrfElement.content
      }
    }

    return await super.request(method, path, options)
  }
}

const client = new OnspaceRestService()
registerConfigurableClient(client)

export default client
